import { Component, ElementRef, inject, model, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

import { AppMenuComponent } from './app.menu.component';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
    standalone: true,
    imports: [
    AppMenuComponent,
    RouterModule
]
})
export class AppSidebarComponent implements OnInit {
    timeout: any = null;
    @ViewChild('menuContainer') menuContainer!: ElementRef;

    public homeLink = '/administration-center';

    public layoutService = inject(LayoutService);
    public el = inject(ElementRef);
    
    public isSuperAdminScreen = model.required<boolean>();

    ngOnInit() {
        if (this.isSuperAdminScreen()){
            this.homeLink = '/super-admin';
        }
    }

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true,
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false,
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored,
        }));
    }
}
